import { useAuth } from "../contexts/AuthContext";
import { createUserLog, createAdminLog } from "../utils/logHelpers";
export const useActivityLogger = () => {
  const { user, loading } = useAuth();

  const logUserActivity = async (
    eventType,
    eventName,
    screenName,
    activity
  ) => {
    try {
      // Validasi input parameters

      if (loading) {
        console.log("User data is still loading, skipping log");
        return;
      }
      if (!eventType || !eventName || !screenName) {
        console.warn("Skipping log: missing required parameters");
        return;
      }

      // Debug user data
      // console.log("Current user from auth context:", user);
      // console.log("Auth loading state:", loading);

      // Fallback untuk mendapatkan user ID
      let userId = "not_logged_in";

      if (user?.username) {
        userId = user.username.toString();
      } else {
        // Fallback: coba ambil dari token
        try {
          const token = localStorage.getItem("access_token");
          if (token) {
            const payload = JSON.parse(atob(token.split(".")[1]));
            userId = payload.username?.toString() || "not_logged_in";
          }
        } catch (tokenError) {
          console.warn("Failed to decode token for user ID:", tokenError);
        }
      }

      // console.log("Using user ID for logging:", userId);

      // Pastikan semua parameter adalah string
      await createUserLog({
        user_id: String(userId),
        event_type: String(eventType),
        event_name: String(eventName),
        screen_name: String(screenName),
        activity: String(
          activity || `User performed ${eventName} on ${screenName}`
        ),
      });
    } catch (error) {
      console.error("Failed to log user activity:", error);
    }
  };

  const logAdminActivity = async (
    eventType,
    eventName,
    contentType,
    contentId,
    actionStatus = "success",
    details = "",
    contentTitle = ""
  ) => {
    try {
      if (loading) {
        console.log("Admin data is still loading, skipping log");
        return;
      }

      // Validasi input parameters
      if (!eventType || !eventName) {
        console.warn("Skipping admin log: missing required parameters");
        return;
      }

      let adminId = "unknown";
      let adminUsername = "unknown";

      // Debug current user context
      // console.log("=== ADMIN LOGGING DEBUG ===");
      // console.log("Current user from auth context:", user);
      // console.log("User object keys:", user ? Object.keys(user) : "no user");
      // console.log("Auth loading state:", loading);
      // Coba ambil dari user context terlebih dahulu
      if (user?.ID || user?.id) {
        adminId = (user.ID || user.id).toString();
        adminUsername =
          user.username ||
          user.Username ||
          user.name ||
          user.email ||
          "unknown";
        console.log(
          "Got from user context - ID:",
          adminId,
          "Username:",
          adminUsername
        );
      } else {
        console.log("No user in context, trying token...");

        // Fallback: coba ambil dari token
        try {
          const token = localStorage.getItem("access_token");
          if (token) {
            const payload = JSON.parse(atob(token.split(".")[1]));
            console.log("Token payload for admin:", payload);
            console.log("Token payload keys:", Object.keys(payload));

            // Coba berbagai field yang mungkin ada di token
            adminId =
              payload.user_id?.toString() ||
              payload.id?.toString() ||
              payload.ID?.toString() ||
              payload.sub?.toString() ||
              "unknown";
            adminUsername =
              payload.username ||
              payload.Username ||
              payload.name ||
              payload.email ||
              payload.preferred_username ||
              "unknown";
            console.log(
              "Got from token - ID:",
              adminId,
              "Username:",
              adminUsername
            );
          } else {
            console.log("No access token found");
          }
        } catch (tokenError) {
          console.warn("Failed to decode token for admin ID:", tokenError);
        }
      }

      // Fallback terakhir: coba ambil dari localStorage profile
      if (adminUsername === "unknown") {
        console.log("Username still unknown, trying localStorage...");
        try {
          // Coba dari admin_profile
          const adminProfile = JSON.parse(
            localStorage.getItem("admin_profile") || "{}"
          );
          console.log("Admin profile from localStorage:", adminProfile);

          if (adminProfile.username || adminProfile.Username) {
            adminUsername =
              adminProfile.username ||
              adminProfile.Username ||
              adminProfile.email ||
              "unknown";
            adminId =
              adminProfile.ID?.toString() ||
              adminProfile.id?.toString() ||
              adminId;
            console.log(
              "Got from admin_profile - ID:",
              adminId,
              "Username:",
              adminUsername
            );
          } else {
            // Coba dari user_data juga
            const userData = JSON.parse(
              localStorage.getItem("user_data") || "{}"
            );
            console.log("User data from localStorage:", userData);

            if (userData.username || userData.Username) {
              adminUsername =
                userData.username ||
                userData.Username ||
                userData.email ||
                "unknown";
              adminId =
                userData.ID?.toString() || userData.id?.toString() || adminId;
              console.log(
                "Got from user_data - ID:",
                adminId,
                "Username:",
                adminUsername
              );
            }
          }
        } catch (e) {
          console.warn("Failed to get profile from localStorage:", e);
        }
      }

      console.log("=== FINAL ADMIN DATA ===");
      console.log("Final admin data for logging:", { adminId, adminUsername });
      console.log("========================");

      // Pastikan semua parameter adalah string
      await createAdminLog({
        admin_user_id: String(adminId),
        admin_username: String(adminUsername),
        event_type: String(eventType),
        event_name: String(eventName),
        content_type: String(contentType || "unknown"),
        content_id: String(contentId || "0"),
        content_title: String(contentTitle || ""),
        action_status: String(actionStatus),
        details: String(details),
      });
    } catch (error) {
      console.error("Failed to log admin activity:", error);
    }
  };

  return { logUserActivity, logAdminActivity, loading };
};
